import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SwiperConfigInterface, SwiperModule, SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { NgSelectModule } from '@ng-select/ng-select';
import { PlyrModule } from 'ngx-plyr';

import { NgApexchartsModule } from 'ng-apexcharts';

import { ApiTranslatePipe } from './pipes/api-translate.pipe';
import { SanitizeHTMLPipe } from './pipes/sanitize-html.pipe';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CoreCommonModule } from '@core/common.module';
import { FormsModule } from '@angular/forms';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

// swiper configuration
const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal',
  slidesPerView: 'auto'
};

@NgModule({
  declarations: [
    ApiTranslatePipe,
    SanitizeHTMLPipe,
  ],
  imports: [
    NgxSkeletonLoaderModule,
    NgSelectModule,
    CoreCommonModule,
    CommonModule,
    PlyrModule,
    SwiperModule,
    FormsModule,
    NgApexchartsModule,
    NgbModule
  ],
  exports: [
    ApiTranslatePipe,
    SanitizeHTMLPipe
  ],
  providers: [
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG
    }
  ]
})
export class SharedModule { }
